import { Box } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { ReactComponent as RalvieLogo } from "../../assets/images/ralvie/ralvie-logo.svg";
import RefreshToken from "../../pages/onboard/RefreshToken";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import "./NavMenuControl.scss";
import NavMenuItemControl from "./NavMenuItemControl";
import { useState } from "react";
import CancelDialog from "./CancelDialog";
import CommonUtil from "../../util/CommonUtils";
import { revokeToken } from "../../services/OnboardService";

export default function NavMenuControl() {
    const navigate = useNavigate();
    const location = useLocation();
    const [openDialog, setOpenDialog] = useState(false);

    const handleSignOut = () => {
        setOpenDialog(true);
    };

    const handleCancelDialogClose = () => {
        setOpenDialog(false);
    };

    const handleConfirmSignOut = () => {
        setOpenDialog(false);
        revokeToken().then((res) => {
            CommonUtil.resetUserSession();
            navigate("/control-panel");
        });
    };

    const planLinks = [
        "/plans",
        "/plan/new"
    ]

    return (
        <div className="sidebarPanel">
            <RefreshToken />
            <Box className="sidebar-content">
                <Box className="Ralvie-logo">
                    <RalvieLogo id="ralvie-logo-icon" className="Ralvie-logo-icon" />
                </Box>

                <Box
                    className={`Dashboard-container ${location.pathname === "/DashboardPanel" ? "nav-menuControl-active" : "nav-menuControl-inactive"}`}
                // onClick={() => navigate("/DashboardPanel")}
                >
                    <Box className="Dashboard-panel">
                        <NavMenuItemControl title="Dashboard" />
                    </Box>
                </Box>

                <Box
                    className={`Subscription-container ${(planLinks.includes(location.pathname) || (location.pathname).startsWith("/plan/view")) ? "nav-menuControl-active" : "nav-menuControl-inactive"}`}
                    onClick={() => navigate("/plans")}
                >
                    <Box className="Subscription-panel">
                        <NavMenuItemControl title="Subscription" id="nav-menuControl-subscription" />
                    </Box>
                </Box>

                <Box
                    className={`Information-container ${location.pathname === "/Information" ? "nav-menuControl-active" : "nav-menuControl-inactive"}`}
                // onClick={() => navigate("/Information")}
                >
                    <Box className="Information-panel">
                        <NavMenuItemControl title="Information" id="nav-menuControl-information" />
                    </Box>
                </Box>

                <Box
                    className={`User-container ${location.pathname === "/User&Access" ? "nav-menuControl-active" : "nav-menuControl-inactive"}`}
                // onClick={() => navigate("/User&Access")}
                >
                    <Box className="User-panel">
                        <NavMenuItemControl title="User & Access" id="nav-menuControl-user&Access" />
                    </Box>
                </Box>
            </Box>

            <Box className="signout-container" onClick={handleSignOut}>
                <NavMenuItemControl
                    id="nav-menuControl-signout" className="nav-menuControl-signout"
                    title={
                        <Box display="flex" alignItems="center" gap="2px">
                            <ArrowBackIcon className="signout-icon" />
                            <span className="">Signout</span>
                        </Box>
                    }
                />
            </Box>

            <CancelDialog
                open={openDialog}
                onClose={handleCancelDialogClose}
                onConfirm={handleConfirmSignOut}
                title="Sign out"
                content="Are you sure you want to sign out?"
                confirmText="Sign out"
                cancelText="Cancel"
            />
        </div>
    );
}
